export const vnNormalize = (value) => {

    const d_VN = '\u0111';
    const D_VN = '\u0110';

    if (value == null) {
        return "";
    }

    return value.replace(d_VN, "d").replace(D_VN, "D").normalize("NFD").replace(/[\u0300-\u036f-\u0111]/g, "");
}

export const vnNormalizePath = (value) => {

    const d_VN = '%C4%91';
    const D_VN = '%C4%90';
    const a1_VN = '%C4%83';
    const A1_VN = '%C4%82';
    const a2_VN = '%C3%A2';
    const A2_VN = '%C3%82';
    const e_VN = '%C3%AA';
    const E_VN = '%C3%8A';
    const O1_VN = '%C3%94';
    const o1_VN = '%C3%B4';
    const O2_VN = '%C6%A0';
    const o2_VN = '%C6%A1';
    const u_VN = '%C6%B0';
    const U_VN = '%C6%AF';

    if (value == null) {
        return "";
    }

    return value.replace(d_VN, "đ").replace(D_VN, "Đ").replace(a1_VN, "ă").replace(A1_VN, "Ă").replace(A2_VN, "Â")
        .replace(a2_VN, "â").replace(e_VN, "ê").replace(E_VN, "Ê").replace(O1_VN, "Ô").replace(o1_VN, "ô")
        .replace(O2_VN, "Ơ").replace(o2_VN, "ơ").replace(u_VN, "ư").replace(U_VN, "Ư");
}
